import generatePicker from 'antd/es/date-picker/generatePicker';
import dayjsGenerateConfig from 'rc-picker/lib/generate/dayjs';
import 'antd/es/date-picker/style/index'; // Import styles

const DayjsDatePicker = generatePicker<any>(dayjsGenerateConfig as any);

export default DayjsDatePicker;
